import { render, staticRenderFns } from "./SvgText.vue?vue&type=template&id=33b279d4&scoped=true&"
import script from "./SvgText.vue?vue&type=script&lang=ts&"
export * from "./SvgText.vue?vue&type=script&lang=ts&"
import style0 from "./SvgText.vue?vue&type=style&index=0&id=33b279d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b279d4",
  null
  
)

component.options.__file = "SvgText.vue"
export default component.exports